import { SelectProps } from "antd";

import { StyledAppSelect } from "./Styled";

const sizeHeightMap = {
    small: 24,
    middle: 32,
    medium: 32,
    large: 40,
} as const;

interface AppSelectProps extends SelectProps {
    fullWidth?: boolean;
}

export const AppSelect = ({
    size = "middle",
    styles,
    fullWidth,
    ...props
}: AppSelectProps) => {
    const height = sizeHeightMap[size];

    const mergedStyles: SelectProps["styles"] =
        typeof styles === "function"
            ? (...args) => {
                  const resolved = styles(...args);
                  return {
                      ...resolved,
                      root: {
                          minHeight: height,
                          ...(fullWidth && { width: "100%" }),
                          ...resolved?.root,
                      },
                  };
              }
            : {
                  ...styles,
                  root: {
                      minHeight: height,
                      ...(fullWidth && { width: "100%" }),
                      ...styles?.root,
                  },
              };

    return <StyledAppSelect size={size} styles={mergedStyles} {...props} />;
};
